// types
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  is_open: false,
  type: "",
  email: ""
};

// ==============================|| SLICE - MENU ||============================== //

const pop = createSlice({
  name: "pop",
  initialState,
  reducers: {
    SIGN_IN_POP: (state, action) => {
      return {
        is_open: true,
        type: "sign-in",
      };
    },
    SIGN_UP_POP: (state, action) => {
      return {
        is_open: true,
        type: "sign-up",
      };
    },
    FORGOT_PASSWORD_POP: (state, action) => {
      return {
        is_open: true,
        type: "forgot-password",
        email: action.payload
      };
    },
    CREATE_PROFILE_POP: (state, action) => {
      return {
        is_open: true,
        type: "create-profile",
      };
    },
    CLOSE_POP: (state, action) => {
      return {
        is_open: false,
        type: "",
      };
    },
  },
});

export default pop.reducer;

export const { SIGN_IN_POP, SIGN_UP_POP, FORGOT_PASSWORD_POP, CLOSE_POP,CREATE_PROFILE_POP } = pop.actions;
